import type {ReactElement} from 'react';
import {Button, IconPlacement, ButtonSize, ButtonType} from '@Components/button';
import {formatScheduleDateTime} from '@Libraries/social-media-wizard-scheduling-library';
import type {WizardScheduleControlsProps} from './wizard-schedule-controls.types';
import {SCHEDULE_CONTROLS_ONBOARDING_ANCHOR_ID} from './wizard-schedule-controls.types';

export function WizardScheduleControls({socialPost, anchorRef, isDisabled, onOpenDateTimePicker}: WizardScheduleControlsProps): ReactElement {
  return (
    <Button
      ref={anchorRef}
      id={SCHEDULE_CONTROLS_ONBOARDING_ANCHOR_ID}
      customClasses="spacing-m-r-2"
      type={ButtonType.SECONDARY}
      size={ButtonSize.MEDIUM}
      icon="icon-pencil"
      iconPlacement={IconPlacement.RIGHT}
      text={formatScheduleDateTime(socialPost)}
      disabled={isDisabled}
      onClick={onOpenDateTimePicker}
    />
  );
}
